import {callAPI} from '@/store/utils'; // eslint-disable-line
import {base} from './utils';

// VAT detail per rate & regime for a source — a banking transaction (leaf) or
// an invoice (TT-7194). Amounts are in minor units (cents) of the company
// accounting currency; `vat_rate` is a percentage (20.0, 5.5). Endpoints:
//   GET /tax-lines?source_type=&source_id=            → TaxLine[]
//   GET /tax-lines/reconcile?source_type=&source_id=  → {base_amount_total, …}
//   PUT /tax-lines {source_type, source_id, lines[]}  → full-replace, origin=manual
// Composed into the `accounting` namespace by ./index.js. Gated behind the
// active accounting module (403 otherwise) — callers gate on `isActivated`.
const sourceKey = (sourceType, sourceId) => `${sourceType}:${sourceId}`;

const sourceQuery = (sourceType, sourceId) => {
  const usp = new URLSearchParams();
  usp.set('source_type', sourceType);
  usp.set('source_id', sourceId);
  return usp.toString();
};

export default {
  state: {
    // key `${source_type}:${source_id}` -> { lines, reconcile, loaded }
    taxLinesBySource: {},
  },
  getters: {
    // Returns { lines, reconcile, loaded } for a source, or null if never fetched.
    taxLinesFor: (state) => (sourceType, sourceId) =>
      state.taxLinesBySource[sourceKey(sourceType, sourceId)] || null,
  },
  mutations: {
    setTaxLinesFor(state, {sourceType, sourceId, lines, reconcile}) {
      const key = sourceKey(sourceType, sourceId);
      const prev = state.taxLinesBySource[key] || {};
      state.taxLinesBySource = {
        ...state.taxLinesBySource,
        [key]: {
          lines: lines !== undefined ? lines || [] : prev.lines || [],
          reconcile: reconcile !== undefined ? reconcile : prev.reconcile || null,
          loaded: true,
        },
      };
    },
  },
  actions: {
    async actionGetTaxLines({commit}, {sourceType, sourceId}) {
      const qs = sourceQuery(sourceType, sourceId);
      const res = await callAPI('GET', `${base()}/tax-lines?${qs}`);
      if (res && !res.error) {
        commit('setTaxLinesFor', {sourceType, sourceId, lines: res.result});
      }
      return res;
    },
    async actionGetTaxReconcile({commit}, {sourceType, sourceId}) {
      const qs = sourceQuery(sourceType, sourceId);
      const res = await callAPI('GET', `${base()}/tax-lines/reconcile?${qs}`);
      if (res && !res.error) {
        commit('setTaxLinesFor', {sourceType, sourceId, reconcile: res.result});
      }
      return res;
    },
    // Full-replace: `lines` is the complete set (an empty array clears them all).
    // The persisted lines come back as origin=manual. lines: [{base_amount,
    // vat_rate, vat_amount?, tax_regime?}].
    async actionPutTaxLines(
      {commit, dispatch},
      {sourceType, sourceId, lines, sourceLastUpdate},
    ) {
      const body = {source_type: sourceType, source_id: sourceId, lines};
      if (sourceLastUpdate) body.source_last_update = sourceLastUpdate;
      const res = await callAPI('PUT', `${base()}/tax-lines`, body);
      if (res && !res.error) {
        // No success toast: the editor shows an inline "Enregistré" status.
        commit('setTaxLinesFor', {sourceType, sourceId, lines: res.result});
      } else {
        dispatch(
          'app/actionAddNotification',
          {
            msg: res?.message || 'Échec de l’enregistrement du détail TVA',
            color: 'red',
            disappearing: true,
          },
          {root: true},
        );
      }
      return res;
    },
  },
};
